import { render, staticRenderFns } from "./MotivosGlosaList.vue?vue&type=template&id=ce584fe6"
import script from "./MotivosGlosaList.vue?vue&type=script&lang=js"
export * from "./MotivosGlosaList.vue?vue&type=script&lang=js"
import style0 from "./MotivosGlosaList.vue?vue&type=style&index=0&id=ce584fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports